export const roleBaseAccessconfig = {
  IM: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
    "/vendormanagement",
  ],
  NM: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
    "/vendormanagement",
  ],
  NH: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
    "/vendormanagement",
  ],
  RM: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
    "/vendormanagement",
  ],
  QC: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
    "/vendormanagement",
  ],
  BSTL: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
    // "/vendormanagement",
  ],
  BS: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    // "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    // "/vendorOnboarding",
    "/createCase",
    // "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
    // "/vendormanagement",
  ],
  MIS: ["/reports"],
  MRA: ["/reports"],
};
